import { createReducer } from '@nextiva/analytics-lib';
import { merge } from 'lodash';
import * as localStore from '../localStore';
import * as Actions from './actions';
var initialState = {
  features: null
};
var reducer = createReducer(initialState).caseAction(Actions.fetchAvailableFeatures.fulfilled, function (state, _a) {
  var meta = _a.meta,
      payload = _a.payload;

  if (meta.featuresFromLocalStore) {
    state.features = merge(payload, meta.featuresFromLocalStore);
  } else {
    state.features = payload;
    localStore.setFeatures(payload);
  }
}).case(Actions.enableFeature, function (state, payload) {
  var feature = state.features && state.features[payload];

  if (feature) {
    feature.isEnabled = true;
    localStore.updateFeature(payload, feature);
  }
}).case(Actions.disableFeature, function (state, payload) {
  var feature = state.features && state.features[payload];

  if (feature) {
    feature.isEnabled = false;
    localStore.updateFeature(payload, feature);
  }
});
export default reducer;